import React from 'react'
import styled, { css } from 'styled-components'
import Icon, { IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'

type Direction = 'left' | 'right'

const StyledArrowButton = styled.button<{
  direction: Direction
  hidden: boolean
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10000;

  ${({ hidden }) =>
    hidden &&
    css`
      display: none;
    `}

  ${({ direction }) => {
    if (direction === 'left') {
      return css`
        left: 20px;
      `
    }

    if (direction === 'right') {
      return css`
        right: 20px;
      `
    }
  }}
`

interface Props {
  hidden: boolean
  onClick?: () => void
  direction: Direction
}

const HeroSliderArrow: React.FC<Props> = ({ hidden, onClick, direction }) => {
  return (
    <StyledArrowButton
      type="button"
      onClick={onClick}
      direction={direction}
      hidden={hidden}
    >
      {direction === 'left' && (
        <Icon size={IconSize.S} asset={IconName.IcArrowLongLeftWhite} />
      )}
      {direction === 'right' && (
        <Icon size={IconSize.S} asset={IconName.IcArrowLongRightWhite} />
      )}
    </StyledArrowButton>
  )
}

export default HeroSliderArrow
